import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const Dashboard_service = {
    behaviorMobileSearch,
    behaviorBroadbandSearch,
    usageSearch,
    getBroadbandAvgAll,
    getOperatorByType,
    getAllRequestByStatus
};

function behaviorMobileSearch(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "report_behavior/getMobileReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function behaviorBroadbandSearch(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "report_behavior/getBroadbandReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function usageSearch(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "report_behavior/getMobileReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getBroadbandAvgAll(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getBroadbandAvgByTechnology/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getOperatorByType(filter){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "operator/getOperatorByType/?authorization=" + json_cookie.token, {params : filter})
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getAllRequestByStatus(status){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_request/getAllRequestByStatus/?authorization="+ json_cookie.token, status)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}